export default {
  MODELS: {
    CATEGORY: 'Category',
    PRODUCT: 'Product',
    CUSTOMER: 'Customer',
    PROVIDER: 'Provider',
    ORDER: 'Order',
    ORDER_ITEM: 'OrderItem',
    IMPORT_ORDER: 'ImportOrder',
    UNIT: 'Unit',
    SETTING: 'Setting'
  },
  USER_ACCOUNT: 'USER_ACCOUNT',
  GOOGLE_ACCOUNT: 'GOOGLE_ACCOUNT',
  PRINT_COUNT: 'PRINT_COUNT',
  SHOW_GRID: 'SHOW_GRID',
  INVOICE_THANK: 'INVOICE_THANK',
  INVOICE_SURCHAGE: 'INVOICE_SURCHAGE',
  SHOW_SIGNATURE: 'SHOW_SIGNATURE',
  SHOW_DEBT: 'SHOW_DEBT',
  SHOW_DEBT_DETAIL: 'SHOW_DEBT_DETAIL',
  SHOW_WARNING_OUT_STOCK: 'SHOW_WARNING_OUT_STOCK',
  SHOW_ORDER_STATUS: 'SHOW_ORDER_STATUS',
  SHOW_DISCOUNT: 'SHOW_DISCOUNT',
  DISCOUNT_TYPE: 'DISCOUNT_TYPE',
  SHOW_ORDER_CUSTOMER: 'SHOW_ORDER_CUSTOMER',
  SURCHAGE_TYPE: 'SURCHAGE_TYPE',
  SHOW_REVENUE: 'SHOW_REVENUE',
  SHOW_PROTECTION: 'SHOW_PROTECTION',
  SHOW_VIETQR: 'SHOW_VIETQR',
  NOTIFY_HIDE_ID: 'NOTIFY_HIDE_ID',
  FONT_SIZE_TYPE: 'FONT_SIZE_TYPE',
  HIDE_NOTIFY: 'HIDE_NOTIFY',
  HIDE_DRAFT_ORDERS: 'HIDE_DRAFT_ORDERS',
  HIDE_VIP_RENEW: 'HIDE_VIP_RENEW',
  HIDE_FINANCIAL: 'HIDE_FINANCIAL',
  HIDE_CHART: 'HIDE_CHART',
  HIDE_TIMEZONE: 'HIDE_TIMEZONE',
  HIDE_POS_DEVICE: 'HIDE_POS_DEVICE',
  SHOW_HOME_CHART: 'SHOW_HOME_CHART',
  SHOW_HOME_REVENUE: 'SHOW_HOME_REVENUE',
  SHOW_HOME_STATISTIAL: 'SHOW_HOME_STATISTIAL',
  SHOW_HOME_FINANCIAL: 'SHOW_HOME_FINANCIAL',
  TIME_FORMAT: 'TIME_FORMAT'
};
